import React, { useState, useEffect } from 'react';
import { PROMISES as FALLBACK_PROMISES } from '../mock';
import { Gem, Sparkles, Truck, RefreshCcw, ShieldCheck, Award } from 'lucide-react';

const ICONS = [Gem, Sparkles, Truck, ShieldCheck, RefreshCcw, Award];

const Card = ({ p, i }) => {
  const Icon = ICONS[i % ICONS.length];
  return (
    <div className="flex flex-col items-center justify-center text-center gap-4 bg-[#FFFFFF] px-6 py-10 w-full h-full">
      <div className="w-20 h-20 rounded-full bg-[#f7f4ee] flex items-center justify-center">
        <Icon size={34} strokeWidth={1.3} className="text-[#999959]" />
      </div>
      <span className="text-[15px] leading-snug tracking-wide text-[#1a1a1a]">{p}</span>
    </div>
  );
};

const IconLabel = ({ p, i }) => {
  const Icon = ICONS[i % ICONS.length];
  return (
    <div className="flex flex-col items-center text-center gap-1.5 w-20">
      <Icon size={22} strokeWidth={1.4} className="text-[#999959]" />
      <span className="text-[10px] leading-tight tracking-wide text-[#1a1a1a]">{p}</span>
    </div>
  );
};

const PromiseMarquee = () => {
  const promises = FALLBACK_PROMISES;

  const loop = [...promises, ...promises];

  return (
    <section className="py-8 lg:py-10 bg-[#FFFFFF] border-y border-[#e5ddce]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-8">
          <h2 className="font-serif text-2xl lg:text-3xl text-[#1a1a1a]">Crafted with intention</h2>
        </div>

        {/* Mobile */}
        <div className="lg:hidden overflow-hidden -mx-6 px-6">
          <div className="flex w-max gap-6 animate-marquee-fast">
            {loop.map((p, i) => (
              <IconLabel key={i} p={p} i={i} />
            ))}
          </div>
        </div>

        {/* Desktop */}
        <div className="hidden lg:block overflow-hidden">
          <div className="flex w-max gap-6 animate-marquee-slow">
            {loop.map((p, i) => (
              <div key={i} className="w-[220px] xl:w-[260px] aspect-[4/5]">
                <Card p={p} i={i} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromiseMarquee;

